import { render } from "./user-coaches.vue?vue&type=template&id=536ce312"
import script from "./user-coaches.vue?vue&type=script&lang=js"
export * from "./user-coaches.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__